import React from 'react';
import './DonationSingle.css';

import { Button, Lightbox, PageTitle, SidebarHeading } from '../../../components';
import { donations } from '../../../constants';

import { FaCircleNotch } from 'react-icons/fa';

import { Link, useLocation } from 'react-router-dom';



const DonationSingle = () => {

  // Get donation details passed via router state
  const location = useLocation();
  const donation = location.state;

  // Extract the amount raised and goal
  const raised = donation.donation.raised;
  const goal = donation.donation.goal;

  // Calculate the percentage of the goal that has been raised
  const percentage = (raised / goal) * 100;

  // Round the calculated percentage to the nearest whole number for display
  const displayPercentage = Math.round(percentage);

  return (
    <>
      {/* Page Title Section */}
      <PageTitle title={donation.title} page={"Donation Single"} />

      <section className='donation-single page-single'>

        <div className='donation-info page-info'>

          {/* Donation Image */}
          <div className='image'>
            <img src={donation.image} alt={donation.title} />
          </div>

          <div className='content'>

            <div className='intro'>

              {/* Donation Title */}
              <h3 className='main-heading'>{donation.title}</h3>

              {/* Progress bar showing donation progress */}
              <div className="skill-bar">
                <span className="skill-progress" style={{ width: `${displayPercentage}%` }}> {/* Filled portion of the progress bar */}
                  <span className="skill-no">{displayPercentage}%</span> {/* Display percentage number inside the progress bar */}
                </span>
              </div>

              {/* Raised amount and Goal amount */}
              <div className='amount'>
                <p><span>${donation.donation.raised}</span> Raised</p>
                <p><span>${donation.donation.goal}</span> Goal</p>
              </div>

              {/* Donate button linking to the donation page */}
              <Button link={`Donation-Form?donation=${encodeURIComponent(donation.title)}`} title={'Donate Now'} />

            </div>

            <div className='sub-section'>

              <h3 className='sub-heading'>Donation Overview:</h3>

              {/* Donation Description */}
              {donation.paragraphs.map((paragraph, index) => (
                <p key={index}>
                  {paragraph}
                </p>
              ))}

            </div>

            {/* Donation Image Gallery */}
            <Lightbox images={donation.gallery} />

            {/* Objectives & Mission Section */}
            <div className='sub-section'>

              <h3 className='sub-heading'>Objectives & Mission:</h3>
              <p>Learn about our goals to serve the community and promote Islamic knowledge and values.</p>

              {/* List of Objectives */}
              <ul>
                {donation.objectives.map((objective, index) => {
                  return <li key={index}><FaCircleNotch className='icon' />{objective}</li>
                })}
              </ul>

            </div>

            {/* Impact and Result Section */}
            <div className='sub-section'>

              <h3 className='sub-heading'>Impact and Result:</h3>

              {donation.results.map((paragraph, index) => (
                <p key={index}>{paragraph}</p>
              ))}

            </div>

          </div>

        </div>

        <div className='sidebar donation-sidebar'>

          <div className='sidebar-item'>

            <SidebarHeading title='All Donations' />

            <div className='box-container'>
              {/* Loop through all donation items and render each one */}
              {donations.map((item) => { 
                return(
                  <div className='post-item' key={item.id}> 
                    <img src={item.image} alt={item.title} />
                    <div className='content'>
                      <Link
                        to={`/Donations/${item.title}`}
                        state={item}
                        className='main-heading'
                      >
                        {item.title}
                      </Link>
                    </div>
                  </div>
                )

              })}
            </div>

          </div>

        </div>

      </section>

    </> 
  );
}

export default DonationSingle;